import Icon, { IconProps } from './Icon';

import RefreshCCWIcon from '../../../assets/icons/refresh-ccw.svg?react';

const RefreshCCW: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <RefreshCCWIcon />
    </Icon>
  );
};

export default RefreshCCW;
